/* eslint-disable */

import * as SchemaTypes from '@freelancerepublik/graphql-types';

import { gql } from '@apollo/client/core';
export type AcceptTermsMutationVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type AcceptTermsMutation = { __typename?: 'Mutation', acceptTerms?: { __typename?: 'User', _id?: string | null, termsList: Array<any> } | null };


export const AcceptTermsDocument = gql`
    mutation acceptTerms {
  acceptTerms {
    _id
    termsList
  }
}
    `;

